const RolePermission = {

    // FIELDS
    "role": "الدور",
    "permission": "الصلاحية",

    // PAGE HEADER
    "assign_permission": "تعيين الصلاحية",

    // ERROR
    "error_role": "يرجى تحديد الدور",
    "error_permission": "يرجى التحقق من وجود صلاحية واحدة على الأقل",

}

export default RolePermission;